<template>
  <div>
    <v-tabs v-model="currentView" color="white" :slider-color="$store.state.theme.brand_color">
      <v-tab href="#holiday" ripple>Holiday</v-tab>
      <v-tab href="#WorkingHour" ripple>Working hour</v-tab>
      <v-tab href="#Consent" ripple>Consent</v-tab>
      <v-tab href="#FollowupMessage" ripple>Followup Message</v-tab>
      <v-tab href="#FollowupMessageReport" ripple>Followup Message Report</v-tab>
    </v-tabs>

    <component :is="currentView"></component>
  </div>
</template>

<script>
import holiday from './holiday.vue'
import WorkingHour from './WorkingHour.vue'
import Consent from './Consent.vue'
import FollowupMessage from './FollowupMessage.vue'
import FollowupMessageReport from './FollowupMessageReport.vue'
export default {
  data() {
    return {
      currentView: null
    }
  },
  created() {
    let vm = this
    if (vm.$route.query.tab) {
      vm.currentView = vm.$route.query.tab
    } else {
      vm.currentView = 'holiday'
    }
  },
  methods: {
    updateSlug() {
      var vm = this
      if (vm.currentView) {
        this.$router.replace({ query: { tab: vm.currentView } })
      }
    }
  },
  watch: {
    currentView: function () {
      this.updateSlug()
    }
  },
  components: {
    holiday,
    WorkingHour,
    Consent,
    FollowupMessage,
    FollowupMessageReport
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/generalixwarroom/main.vue